module.exports = __webpack_public_path__ + "static/media/boom-zuurstof.11162703.png";